import React from 'react';
import { Helmet } from 'react-helmet';
import Template from '../../components/templates/default';
import Main from '../../containers/Main';
import UpdateUserContainer from '../../containers/UpdateUser/index';

const UpdateUserPage = () => {
  const pageTitle = 'Confirmar CPF - Experimente';
  return (
    <Template className="confirm-cpf-page">
      <Helmet title={pageTitle} />
      <Main pageTitle={pageTitle}>
        <UpdateUserContainer />
      </Main>
    </Template>
  );
};

export default UpdateUserPage;
